import styled from 'styled-components';
import { Link as LinkOriginal } from 'react-router-dom';
import { fontBody, fontTitle } from 'Styles/fonts';
import { Title } from '../LinkCard/LinkCard.styled';

import LinkCardOriginal from '../LinkCard/LinkCard';

export const AccountNavSettings = styled.div``;

export const SettingsLinksContainer = styled.div`
  margin-bottom: 16px;
`;

export const Link = styled(LinkOriginal)`
  text-decoration: none;
`;

export const LinkCard = styled(LinkCardOriginal)`
  background-color: var(--background);
  margin-bottom: 12px;

  ${Title} {
    ${fontTitle(16)}
  }
`;

export const LogOut = styled.p`
  ${fontBody(16)}
  color: var(--foreground);
  text-decoration: none;
`;

export default {};
